export interface CommercialSalesGoalSnapshot {
  month: string;
  startsOn: string;
  endsOn: string;
  salesCount: number;
  targetSales: number | null;
}

export function formatSalesGoalCounter(salesCount: number, targetSales: number | null): string {
  if (targetSales == null) {
    return `${salesCount} / Sem meta`;
  }

  return `${salesCount}/${targetSales}`;
}

export function formatSalesGoalRange(startsOn: string, endsOn: string): string {
  const start = formatIsoDate(startsOn);
  const end = formatIsoDate(endsOn);
  if (!start || !end) {
    return '';
  }

  return `${start} a ${end}`;
}

function formatIsoDate(value: string): string | null {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!match) {
    return null;
  }

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const date = new Date(Date.UTC(year, month - 1, day));
  if (
    date.getUTCFullYear() !== year
    || date.getUTCMonth() !== month - 1
    || date.getUTCDate() !== day
  ) {
    return null;
  }

  return new Intl.DateTimeFormat('pt-BR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(date);
}
